'use client';

enum SpeculationRuleTypes {
  type = 'speculationrules',
}

export function addSpeculationRule(enrollmentUrl: string) {
  if (typeof window !== 'undefined') {
    const speculationScript = window?.document.createElement('script');
    speculationScript.type = SpeculationRuleTypes.type;
    const speculationRules = {
      prefetch: [{ urls: [enrollmentUrl] }],
    };
    speculationScript.textContent = JSON.stringify(speculationRules);
    document.body?.append(speculationScript);
  }
}
